import React, {
  createContext,
  useContext,
  useState,
  useCallback,
} from "react";
import MessageAlert from "../components/MessageAlert/MessageAlert";

const AlertContext = createContext(null);

export const useAlert = () => {
  const ctx = useContext(AlertContext);
  if (!ctx) {
    throw new Error("useAlert must be used within an AlertProvider");
  }
  return ctx;
};

export const AlertProvider = ({ children }) => {
  const [alerts, setAlerts] = useState([]);

  const showAlert = useCallback(
    (message, type = "success", persistent = false) => {
      const id = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

      setAlerts((prev) => [...prev, { id, message, type, persistent }]);

      if (!persistent) {
        setTimeout(() => {
          setAlerts((prev) => prev.filter((alert) => alert.id !== id));
        }, 3000);
      }
    },
    [],
  );

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}

      {/* Alerts UI */}
      <div className="message-alert-container">
        {alerts.map((alert) => (
          <MessageAlert
            key={alert.id}
            id={alert.id}
            message={alert.message}
            type={alert.type}
            persistent={alert.persistent}
            onClose={() => {
              setAlerts((prev) => prev.filter((a) => a.id !== alert.id));
            }}
          />
        ))}
      </div>
    </AlertContext.Provider>
  );
};
